import React from 'react';
import { Popover, Empty } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import './styles.css';

// No notification feed exists on the server yet, so this shows an empty state.
const content = (
  <div className="notificationPanel">
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="You're all caught up"
    />
  </div>
);

const Notification = () => {
  return (
    <Popover
      content={content}
      title="Notifications"
      trigger="click"
      placement="bottomRight"
    >
      <button type="button" className="icon-btn" aria-label="Notifications">
        <BellOutlined />
      </button>
    </Popover>
  );
};

export default Notification;
